import { useSelector } from 'react-redux';

import {
    getAlertsCount,
    getFetchAlertsAfter,
} from '../../../../../state/app/alertsPage';

export const useAlertCount = () => useSelector(getAlertsCount);
export const useFetchAlertsAfter = () => useSelector(getFetchAlertsAfter);
